var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ContentLayout", {
    attrs: {
      title: _vm.$t("label_essweb_customForm_form_newTitle"),
      pad: "0",
      widthClass: "max-1000",
      initData: _vm.customFormData,
      checkData: [
        "application_type_name",
        "type_code",
        "application_type_desc",
        "flow_template_uuid",
        "color_code",
        "sequence",
      ],
    },
    on: {
      change: function (changed) {
        return (_vm.isChanged = changed)
      },
    },
    scopedSlots: _vm._u([
      {
        key: "page-main",
        fn: function () {
          return [
            _c("Stepper", {
              attrs: { curStep: _vm.curStep, items: _vm.stepper },
              scopedSlots: _vm._u([
                {
                  key: "content-1",
                  fn: function () {
                    return [
                      _c(
                        "v-form",
                        { ref: "form", attrs: { "lazy-validation": "" } },
                        [
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "12",
                                    md: "12",
                                    lg: "12",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c("v-switch", {
                                    staticClass: "ml-4",
                                    attrs: {
                                      color: "primary",
                                      label: _vm.customFormData.status
                                        ? _vm.$t(
                                            "label_essweb_customForm_form_activeLabel"
                                          )
                                        : "",
                                    },
                                    model: {
                                      value: _vm.customFormData.status,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.customFormData,
                                          "status",
                                          $$v
                                        )
                                      },
                                      expression: "customFormData.status",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "12",
                                    md: "8",
                                    lg: "8",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c("inputTextFiledMultiLang", {
                                    attrs: {
                                      bindData:
                                        _vm.customFormData
                                          .application_type_name,
                                      maxlength: "100",
                                      label: _vm.$t(
                                        "label_essweb_customForm_form_customFormNameLabel"
                                      ),
                                      rules: _vm.$GetRules(
                                        ["_Require_Rules"],
                                        [null]
                                      ),
                                    },
                                    on: {
                                      change: function (valueArr) {
                                        _vm.customFormData.application_type_name =
                                          valueArr
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "12",
                                    md: "4",
                                    lg: "4",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c("normalInputTextFiled", {
                                    attrs: {
                                      label: _vm.$t(
                                        "label_essweb_customForm_form_customFormCodeLabel"
                                      ),
                                      maxlength: "100",
                                      rules: _vm.$GetRules(
                                        ["_Require_Rules", "_Length_Rules"],
                                        [null, 100]
                                      ),
                                    },
                                    model: {
                                      value: _vm.customFormData.type_code,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.customFormData,
                                          "type_code",
                                          $$v
                                        )
                                      },
                                      expression: "customFormData.type_code",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "12",
                                    md: "12",
                                    lg: "12",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c("inputTextFiledMultiLang", {
                                    attrs: {
                                      bindData:
                                        _vm.customFormData
                                          .application_type_desc,
                                      maxlength: "100",
                                      label: _vm.$t(
                                        "label_essweb_customForm_form_customFormDescLabel"
                                      ),
                                    },
                                    on: {
                                      change: function (valueArr) {
                                        _vm.customFormData.application_type_desc =
                                          valueArr
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "12",
                                    md: "8",
                                    lg: "8",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c(
                                    "v-sheet",
                                    {
                                      staticClass:
                                        "mrc_text_require text--secondary",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "label_essweb_customForm_form_customFormApprovalFlowLabel"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _c("v-autocomplete", {
                                    attrs: {
                                      items: _vm.approvalFlows,
                                      "item-text": "view_fields",
                                      "item-value": "value_field",
                                      "single-line": "",
                                      rules: _vm.$GetRules(
                                        ["_Require_Rules"],
                                        [null]
                                      ),
                                      "menu-props": {
                                        offsetY: true,
                                        transition: "slide-y-transition",
                                        rounded: true,
                                        contentClass: "elevation-4",
                                      },
                                      filled: "",
                                      label: _vm.$t(
                                        "label_essweb_customForm_form_customFormApprovalFlowLabel"
                                      ),
                                      dense: "",
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "no-data",
                                        fn: function () {
                                          return [_c("noContent")]
                                        },
                                        proxy: true,
                                      },
                                    ]),
                                    model: {
                                      value:
                                        _vm.customFormData.flow_template_uuid,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.customFormData,
                                          "flow_template_uuid",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "customFormData.flow_template_uuid",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "12",
                                    md: "4",
                                    lg: "4",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c(
                                    "v-sheet",
                                    {
                                      staticClass:
                                        "mrc_text_require text--secondary",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "label_essweb_customForm_form_colorLabel"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _c("SelectColor", {
                                    attrs: {
                                      items: _vm.$Colors,
                                      rules: _vm.$GetRules(
                                        ["_Require_Rules"],
                                        [null]
                                      ),
                                    },
                                    model: {
                                      value: _vm.customFormData.color_code,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.customFormData,
                                          "color_code",
                                          $$v
                                        )
                                      },
                                      expression: "customFormData.color_code",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "12",
                                    md: "12",
                                    lg: "12",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c("numberInputTextFiled", {
                                    attrs: {
                                      rules: _vm.$GetRules(
                                        ["_Number_negative", "_Length_Rules"],
                                        [null, 15]
                                      ),
                                      label: _vm.$t(
                                        "label_essweb_customForm_form_sequenceLabel"
                                      ),
                                      isNotRequire: "",
                                    },
                                    model: {
                                      value: _vm.customFormData.sequence,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.customFormData,
                                          "sequence",
                                          $$v
                                        )
                                      },
                                      expression: "customFormData.sequence",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "12",
                                    md: "12",
                                    lg: "12",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c(
                                    "v-sheet",
                                    { staticClass: "text--secondary" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "label_essweb_customForm_form_remarkLabel"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _c("v-textarea", {
                                    attrs: {
                                      rows: "5",
                                      "no-resize": "",
                                      maxlength: "500",
                                      dense: "",
                                      counter: "500",
                                      "single-line": "",
                                      filled: "",
                                    },
                                    model: {
                                      value: _vm.customFormData.remarks,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.customFormData,
                                          "remarks",
                                          $$v
                                        )
                                      },
                                      expression: "customFormData.remarks",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "content-2",
                  fn: function () {
                    return [
                      _c(
                        "v-container",
                        {
                          staticClass: "mrc-grey rounded-lg",
                          attrs: { fluid: "" },
                        },
                        _vm._l(_vm.NoticeList, function (item, index) {
                          return _c(
                            "v-sheet",
                            {
                              key: index,
                              staticClass:
                                "transparent d-flex pa-0 my-3 align-center",
                            },
                            [
                              _c("v-hover", {
                                attrs: { "open-delay": "100" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (ref) {
                                        var hover = ref.hover
                                        return [
                                          _c(
                                            "v-card",
                                            {
                                              staticClass:
                                                "\n                  white\n                  d-flex\n                  flex-row\n                  justify-space-around\n                  flex-grow-1\n                  ml-3\n                  pa-2\n                  align-center\n                ",
                                              attrs: {
                                                elevation: hover ? 10 : 2,
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    width: "20px",
                                                  },
                                                },
                                                [
                                                  _c("svg-icon", {
                                                    attrs: {
                                                      size: "24",
                                                      fill: "black",
                                                      iconClass:
                                                        "LabeledColour",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "span",
                                                { staticClass: "ml-2" },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$getCommonLangValue(
                                                          item[
                                                            "application_type_notice_point_" +
                                                              item.number
                                                          ]
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                              _c("v-spacer"),
                                              _c(
                                                "div",
                                                [
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      staticClass: "ma-2",
                                                      attrs: {
                                                        icon: "",
                                                        "x-small": "",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.toEditNotice(
                                                            item
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "material-icons-round",
                                                        },
                                                        [_vm._v("edit")]
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      staticClass: "ma-2",
                                                      attrs: { icon: "" },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.onDeleteNotice(
                                                            item.number
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "material-icons-round",
                                                        },
                                                        [_vm._v("delete")]
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                            ],
                            1
                          )
                        }),
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "content-3",
                  fn: function () {
                    return [
                      _c("Tabler", {
                        attrs: {
                          headers: _vm.headers,
                          items: _vm.desserts,
                          border: "",
                          avPerPage: 50,
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "item.sequence",
                            fn: function (ref) {
                              var item = ref.item
                              return [_vm._v(" " + _vm._s(item.sequence) + " ")]
                            },
                          },
                          {
                            key: "item.label",
                            fn: function (ref) {
                              var item = ref.item
                              return [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$getCommonLangValue(
                                        item.custom_field_name
                                      )
                                    ) +
                                    " "
                                ),
                              ]
                            },
                          },
                          {
                            key: "item.type",
                            fn: function (ref) {
                              var item = ref.item
                              return [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$getCommonLangValue(
                                        item.custom_field_data_type_name
                                      )
                                    ) +
                                    " "
                                ),
                              ]
                            },
                          },
                          {
                            key: "item.mandatory",
                            fn: function (ref) {
                              var item = ref.item
                              return [
                                Number(item.is_required)
                                  ? _c(
                                      "span",
                                      { staticClass: "material-icons-round" },
                                      [_vm._v("check")]
                                    )
                                  : _c(
                                      "span",
                                      { staticClass: "material-icons-round" },
                                      [_vm._v("close")]
                                    ),
                              ]
                            },
                          },
                          {
                            key: "item.action",
                            fn: function (ref) {
                              var item = ref.item
                              return [
                                _c(
                                  "div",
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        staticClass: "ma-2",
                                        attrs: { icon: "", "x-small": "" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.toEditItem(item)
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "material-icons-round",
                                          },
                                          [_vm._v("edit")]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "v-btn",
                                      {
                                        staticClass: "ma-2",
                                        attrs: { icon: "" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onDeleteItem(item.uuid)
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "material-icons-round",
                                          },
                                          [_vm._v("delete")]
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                          {
                            key: "footer",
                            fn: function () {
                              return [
                                _c(
                                  "v-container",
                                  { staticClass: "pa-0", attrs: { fluid: "" } },
                                  [
                                    _c("v-divider"),
                                    _c(
                                      "v-btn",
                                      {
                                        staticClass: "my-2 text-capitalize",
                                        attrs: {
                                          text: "",
                                          small: "",
                                          color: "primary",
                                        },
                                        on: {
                                          click: function ($event) {
                                            _vm.showNewItem = true
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t(
                                                "label_essweb_customForm_form_newItemLabel"
                                              )
                                            ) +
                                            " "
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticClass: "material-icons-round",
                                          },
                                          [_vm._v("add")]
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ]),
                      }),
                    ]
                  },
                  proxy: true,
                },
              ]),
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "page-actions",
        fn: function () {
          return [
            _c("CardActions", {
              attrs: {
                newBtn:
                  _vm.step == _vm.curStep && _vm.curStep != 0 ? true : false,
                step: _vm.step == _vm.curStep ? false : true,
                preStep: _vm.curStep > 1 ? true : false,
              },
              on: {
                next: _vm.toNext,
                pre: function ($event) {
                  _vm.curStep = _vm.curStep - 1
                },
                new: _vm.toNew,
                cancel: function ($event) {
                  return _vm.$toBack(_vm.isChanged)
                },
              },
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "tools-main",
        fn: function () {
          return [
            _c("newNotice", {
              attrs: {
                show: _vm.showNewNotice,
                PropertyData: _vm.NoticePropertyData,
              },
              on: {
                close: function ($event) {
                  _vm.showNewNotice = false
                  _vm.NoticePropertyData = null
                },
                onNew: _vm.onNewNotice,
              },
            }),
            _c("newItem", {
              attrs: { show: _vm.showNewItem },
              on: {
                close: function ($event) {
                  _vm.showNewItem = false
                },
                onNew: _vm.onNewItem,
              },
            }),
            _c("editItem", {
              attrs: {
                show: _vm.showEditItem,
                PropertyData: _vm.curItemPropertyData,
              },
              on: {
                close: function ($event) {
                  _vm.showEditItem = false
                  _vm.curItemPropertyData = null
                },
                onEdit: _vm.onEditItem,
              },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }